import type { ATTACHMENT_TYPES } from 'src/constants/attachmentTypes';

type AttachmentType = {
  type: ATTACHMENT_TYPES;
};

export const sortAttachmentType = <T extends AttachmentType>(
  attachments: T[],
): T[] => [...attachments].sort((a, b) => a.type - b.type);
